import { FormControl } from '@angular/forms';

import { CheckListDetailsSavedItemInterface } from '@modals/check-list-details/interfaces/check-list-details-saved-item.interface';
import { CheckListDetailsTableRowInterface } from '@modals/check-list-details/interfaces/check-list-details-table-row.interface';

/**
 * Maps a saved checklist item to a sortable table row with a completed checkbox control.
 *
 * @param savedItem - item returned by getCheckListBySR
 * @param canEdit - whether the current role may toggle completion
 */
export function mapCheckListDetailsSavedItemToTableRow(
  savedItem: CheckListDetailsSavedItemInterface,
  canEdit: boolean,
): CheckListDetailsTableRowInterface {
  const isCheckedControl = new FormControl(savedItem.isChecked, { nonNullable: true });

  if (!canEdit) {
    isCheckedControl.disable({ emitEvent: false });
  }

  return {
    itemName: savedItem.checkListItemName,
    createdBy: savedItem.createdBy,
    createdOn: savedItem.createdOn,
    lastUpdatedBy: savedItem.lastUpdatedBy,
    lastUpdatedByName: savedItem.lastUpdatedByName,
    lastUpdatedOn: savedItem.lastUpdatedOn,
    isCheckedControl,
  };
}
